module.exports = __webpack_public_path__ + "components/switch-units/static/icon-settings-9ee728b0a345c9792fd90dade3b4f56e.svg";